__w_pdfjs_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))


// WEBPACK FOOTER //
// webpack://pdfjs-dist/build/pdf.worker/webpack/runtime/hasOwnProperty shorthand